import { useState, useEffect, useRef, useCallback } from 'react';
import { CountdownInSeconds } from '@mfe-presentation/constants/userVerification';

export const useTimer = () => {
    const [seconds, setSeconds] = useState(CountdownInSeconds);
    const intervalIdRef = useRef<ReturnType<typeof setInterval> | null>(null);

    // Start the timer, if a timer is already running, restart the timer
    const startTimer = useCallback(() => {
        if (intervalIdRef.current) resetTimer();
        intervalIdRef.current = setInterval(() => {
            setSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 0));
        }, 1000);
    }, []);

    // Stop the timer, the countdown (seconds) will be paused at x seconds
    const stopTimer = useCallback(() => {
        if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
        }
    }, []);

    // Reset the timer, the countdown will be reset to max seconds
    const resetTimer = useCallback(() => {
        setSeconds(CountdownInSeconds);
        stopTimer();
    }, [stopTimer]);

    useEffect(() => {
        return () => {
            // Clean up timer when the component unmounts
            stopTimer();
        };
    }, [stopTimer]);

    const isTimerRunning = intervalIdRef.current !== null && seconds > 0;

    return { seconds, startTimer, isTimerRunning, stopTimer };
};
